import React from "react";
import loadable from "@loadable/component";
import { LazyComponent } from "../LazyComponent";
import { TemplatesGalleryProps } from "./TemplatesGallery";

const TemplatesGallery = loadable(() => import("./TemplatesGallery"));

export const TemplatesGalleryLazyLoad: React.FC<TemplatesGalleryProps> = (
  props: TemplatesGalleryProps
) => {
  return <LazyComponent component={TemplatesGallery} componentProps={{ ...props }} />;
};

export default TemplatesGalleryLazyLoad;
